import React from 'react';
import { SaveSearch } from '../save-search/save-search';
import { BodyItem } from './bodyItem/body-item';

import { StyledFooter, StyledTilte, StyledWrapper } from './index.style';

const NoSearchResults = ({
    isZeroResults,
    searchQuery,
}: {
    isZeroResults: boolean;
    searchQuery: string;
}) => {
    return isZeroResults && searchQuery ? (
        <StyledWrapper>
            <StyledTilte>
                <span>0</span>results for<span>'{searchQuery}'</span>
            </StyledTilte>
            <BodyItem label="Check the spelling" />
            <BodyItem label="Try adding or removing words" />
            <BodyItem label="Try browsing the categories" />
            <StyledFooter>
                Save this search to receive email alerts and notifications when new items are
                available.
            </StyledFooter>
            <SaveSearch isNoSearchResults />
        </StyledWrapper>
    ) : (
        <></>
    );
};

export default NoSearchResults;
